var map = {
	"./readonly-form/Typekey.js": "./common/js/src/edge/policycommon/common/directives/schedules/dataItems/readonly-form/Typekey.js",
	"./readonly-table/Typekey.js": "./common/js/src/edge/policycommon/common/directives/schedules/dataItems/readonly-table/Typekey.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./common/js/src/edge/policycommon/common/directives/schedules/dataItems sync recursive ^\\.\\/.*\\/Typekey\\.js$";